import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { isNullish } from '@app/shared/helpers/is-nullish';

export interface InvitationB2bClientDisplayPartnerInfosComponentData {
  invitation: any;
}

@Component({
  selector: 'app-invitation-b2b-client-display-partner-infos',
  templateUrl: './invitation-b2b-client-display-partner-infos.component.html',
  styleUrls: ['./invitation-b2b-client-display-partner-infos.component.scss'],
})

export class InvitationB2bClientDisplayPartnerInfosComponent {


  constructor(
    private dialogRef: MatDialogRef<InvitationB2bClientDisplayPartnerInfosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InvitationB2bClientDisplayPartnerInfosComponentData,
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  get hasName(): boolean {
    return !isNullish(this.data.invitation.extras.partner.name) && this.data.invitation.extras.partner.name !== '';
  }

  get hasEmail(): boolean {
    return !isNullish(this.data.invitation.extras.partner.email) && this.data.invitation.extras.partner.email !== '';
  }

  get hasSkills(): boolean {
    return this.data.invitation.extras.partner.skills?.length > 0;
  }

  get hasAddresse(): boolean {
    return this.data.invitation.extras.partner.addresses?.length > 0;
  }

  get partnerDescription(): string {
    switch (window['CONST_LANG'].shortcode) {
      case 'fr':
        return this.data.invitation.extras.partner.description;
        break;
      case 'en':
        return this.data.invitation.extras.partner.description_en;
      break;
      case 'de':
        return this.data.invitation.extras.partner.description_de;
      break;
      case 'es':
        return this.data.invitation.extras.partner.description_es;
      break;
      case 'it':
        return this.data.invitation.extras.partner.description_it;
        break;
      default:
        break;
    }
  }

  get hasDescription(): boolean {
    return !isNullish(this.partnerDescription) && this.partnerDescription !== '';
  }
}
